import { utils, writeFile } from "xlsx";

const DownloadExcelFile = (data, fileName) => {
	const worksheet = utils.json_to_sheet(data);
	const workbook = utils.book_new();
	utils.book_append_sheet(workbook, worksheet, "Sheet1");
	writeFile(workbook, `${fileName}.xlsx`);
};
export { DownloadExcelFile };

const slugify = str => {
	str = str.replace(/^\s+|\s+$/g, "");
	str = str.toLowerCase();
	var from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
	var to = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
	for (var i = 0, l = from.length; i < l; i++) {
		str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
	}
	str = str
		.replace(/[^a-z0-9 -]/g, "_")
		.replace(/\s+/g, "_")
		.replace(/-+/g, "_")
		.replace(/_+/g, "_");
	if (str.endsWith("_")) str = str.substring(0, str.length - 1);
	if (str.startsWith("_")) str = str.substring(1);
	return str;
};
export { slugify };

const allStrings = arr => {
	let final = [];
	for (let row of arr) {
		let single = {};
		for (let key in row) {
			single[key] = row[key]?.toString();
		}
		final.push(single);
	}
	return final;
};
export { allStrings };
